import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { useTranslations } from "@jti/ui/providers/useTranslations";
import { useAddProduct } from "../../hooks/useAddProduct";
import { PriceTiersContext } from "../../providers/PriceTiersContext";
import AddToCartButton from "./AddToCartButton";
const AddProductButton = ({ sku, bundle, onError, isLoaded, isDisabled, onClick, customBuyCtaLabel, consentStatus, }) => {
    const { __ } = useTranslations();
    const { selectedPriceTier } = useContext(PriceTiersContext);
    const { isRunning, addProductToCart } = useAddProduct(sku, bundle, false, onError);
    const quantity = selectedPriceTier?.quantity ?? 1;
    const isLoading = isRunning || !isLoaded;
    const _onClick = () => {
        try {
            onClick?.();
            addProductToCart(quantity, undefined, consentStatus);
        }
        catch (error) {
            if (error instanceof Error) {
                console.error(error.message);
            }
        }
    };
    return (_jsx(AddToCartButton, { onClick: _onClick, isLoading: isLoading, testId: "pdpAddToProduct", label: customBuyCtaLabel || __("product.button.addtocart"), isDisabled: isDisabled }));
};
export default AddProductButton;
//# sourceMappingURL=AddProductButton.js.map